import { render, staticRenderFns } from "./InputAssessment.vue?vue&type=template&id=f952feac&scoped=true"
import script from "./InputAssessment.vue?vue&type=script&lang=js"
export * from "./InputAssessment.vue?vue&type=script&lang=js"
import style0 from "./InputAssessment.vue?vue&type=style&index=0&id=f952feac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f952feac",
  null
  
)

export default component.exports